module.exports = ["ממש עכשיו",["לפני שנייה","לפני %s שניות"],["לפני דקה","לפני %s דקות "],["לפני שעה","לפני %s שעות"],["אתמול"," לפני %s שעות"],["לפני שבוע","לפני %s שבועות"],["לפני חודש","לפני %s חודשים"],["לפני שנה","לפני %s שנים"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/he-IL.json
// module id = uJET
// module chunks = 1